import { render, staticRenderFns } from "./autoConfigTables.vue?vue&type=template&id=33f17b96&scoped=true"
import script from "./autoConfigTables.vue?vue&type=script&lang=js"
export * from "./autoConfigTables.vue?vue&type=script&lang=js"
import style0 from "./autoConfigTables.vue?vue&type=style&index=0&id=33f17b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f17b96",
  null
  
)

export default component.exports